var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-area" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款单据号")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("span", [_vm._v(_vm._s(_vm.rcvVoucher.no))]),
            _vm._v(" "),
            _vm.rcvVoucher.prePayFlag
              ? _c(
                  "el-tag",
                  { staticClass: "ml10", attrs: { type: "danger" } },
                  [_vm._v("预付")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("来源类型")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.srcVoucherTypeMap[_vm.rcvVoucher.srcVoucherType]))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("来源单据号")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [_vm._v(_vm._s(_vm.rcvVoucher.srcVoucherInnerNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款主题")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.subject))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款状态")]),
        _vm._v(" "),
        _vm.rcvVoucher.rcvResult == 0
          ? _c("div", { staticClass: "content" }, [_vm._v("待收款")])
          : _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.rcvResultMap[_vm.rcvVoucher.rcvResult]))
            ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("付款方")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.payerRealComName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("付款方标识码")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.payerInnerNo))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("付款银行")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.payBankName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("付款卡号")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.payCardNo || ""))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款途径")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvWayMap[_vm.rcvVoucher.rcvWay]))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款方式")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.rcvMethodMap[_vm.rcvVoucher.rcvMethod]))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款形式")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [_vm._v(_vm._s(_vm.rcvFormMap[_vm.rcvVoucher.rcvForm]))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款银行")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.rcvBankName || ""))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("收款卡号")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.rcvVoucher.rcvCardNo || ""))
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.rcvVoucher.rcvPhaseId != -1
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("当前收款阶段")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.rcvVoucher.rcvPhaseName || "") +
                    " (付款比例" +
                    _vm._s((_vm.rcvVoucher.ratio || 0).toFixed(2)) +
                    "%)"
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("本次需收金额")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm.rcvVoucher.prePayFlag
            ? _c("span", { staticClass: "font-red font16" }, [
                _c("b", [
                  _vm._v(
                    _vm._s(parseFloat(_vm.rcvVoucher.amountPre || 0).toFixed(2))
                  )
                ]),
                _vm._v(" 元")
              ])
            : _c("span", { staticClass: "font-red font16" }, [
                _c("b", [
                  _vm._v(
                    _vm._s(parseFloat(_vm.rcvVoucher.amount || 0).toFixed(2))
                  )
                ]),
                _vm._v(" 元")
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.payItems != null && _vm.payItems.length > 0
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.payItems, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "rcvPhaseName",
                  label: "阶段名称"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "amount",
                  label: "本次应收款金额(元)",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s((scope.row.amount || 0).toFixed(2)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "amount",
                  label: "本次实际收款金额(元)",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s((scope.row.amount || 0).toFixed(2)))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.rcvVoucher.prePayFlag
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("本次实际收款金额")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.rcvVoucher.prePayFlag
                ? _c("span", { staticClass: "font-red font16" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          parseFloat(_vm.rcvVoucher.amountPre || 0).toFixed(2)
                        )
                      )
                    ]),
                    _vm._v(" 元")
                  ])
                : _c("span", { staticClass: "font-red font16" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          parseFloat(_vm.rcvVoucher.amountPost || 0).toFixed(2)
                        )
                      )
                    ]),
                    _vm._v(" 元")
                  ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.optionFlag == "chaKan"
        ? _c("div", [
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("申请状态")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.applyStateMap[_vm.rcvVoucher.applyState]))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("申请描述")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.rcvVoucher.applyDesc))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("审核状态")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.auditStateMap[_vm.rcvVoucher.auditState]))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("审核描述")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.rcvVoucher.auditDesc))])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("留言")]),
        _vm._v(" "),
        _vm.optionFlag == "fuKuan"
          ? _c("div", { staticClass: "content" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rcvVoucher.memo,
                    expression: "rcvVoucher.memo"
                  }
                ],
                staticStyle: { width: "320px", height: "90px" },
                domProps: { value: _vm.rcvVoucher.memo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.rcvVoucher, "memo", $event.target.value)
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.optionFlag != "fuKuan"
          ? _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.rcvVoucher.memo))])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.optionFlag == "shenHe"
        ? _c("div", [
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("审核结果")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                _vm._l(_vm.auditStateList, function(auditStateInfo) {
                  return _c(
                    "el-radio",
                    {
                      staticClass: "radio",
                      attrs: { label: auditStateInfo.value },
                      model: {
                        value: _vm.rcvVoucher.auditState,
                        callback: function($$v) {
                          _vm.$set(_vm.rcvVoucher, "auditState", $$v)
                        },
                        expression: "rcvVoucher.auditState"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(auditStateInfo.text))])]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("审核描述")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rcvVoucher.auditDesc,
                      expression: "rcvVoucher.auditDesc"
                    }
                  ],
                  staticStyle: { width: "320px", height: "90px" },
                  domProps: { value: _vm.rcvVoucher.auditDesc },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.rcvVoucher, "auditDesc", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("收款详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f70ebca2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f70ebca2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/payment/RcvVoucherInfo.vue
// module id = 2034
// module chunks = 1